(function() {
    angular
        .module("globalSearchModule")
        .config(globalSearchRouter)

    globalSearchRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function globalSearchRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
        .state("global-search", {
            url: "/global-search",
            templateUrl: "app/components/global-search/global-search.view.html",
            controller : "GlobalSearchController"
        })

        .state("global-search.devices", {
            url: "/devices",
            views: {
                "global_search_tab": {
                    templateUrl: "app/components/global-search/devices-search.view.html",
                    controller : "GlobalSearchDevicesController"
                }
            }
        })

        .state("global-search.customers", {
            url: "/customers",
            views: {
                "global_search_tab": {
                    templateUrl: "app/components/global-search/customers-search.view.html",
                    controller : "GlobalSearchCustomersController"
                }
            }
        })

        .state("global-search.users", {
            url: "/users",
            views: {
                "global_search_tab": {
                    templateUrl: "app/components/global-search/users-search.view.html",
                    controller : "GlobalSearchUsersController"
                }
            }
        })

        $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
